<template>
  <div>
    <form @submit.prevent="addNewTreatment">
      <div class="md-layout-item">
        <md-field>
          <label>Treatment name</label>
          <md-input
            v-model="form1.treatmentName"
            ref="treatmentNameInput"
          ></md-input>
        </md-field>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-field>
            <label for="Categories">Category</label>
            <md-select
              name="categories"
              v-model="form1.selectedCategory"
              multiple
              placeholder="Select Category"
            >
              <md-option v-for="item in categories" :key="item" :value="item">{{
                item
              }}</md-option>
            </md-select>
            <span class="md-helper-text">
              Click
              <a
                href="javascript: void(0)"
                @click="showCreateCategory = !showCreateCategory"
                >here</a
              >
              to manage categories
            </span>
          </md-field>
        </div>
        <div class="md-layout-item">
          <md-field>
            <label for="priceText">Price text</label>
            <md-input v-model="form1.priceText" name="priceText"></md-input>
            <span class="md-helper-text">
              Any text, for ex.:
              <small>This month - £79 only</small>
            </span>
          </md-field>
        </div>
      </div>
    </form>
    <transition name="fade">
      <form
        class="md-layout"
        @submit.prevent="addRemoveCategory"
        v-if="showCreateCategory"
      >
        <md-card class="md-layout-item">
          <md-card-header>
            <md-subheader
              >Create a new treatment category or remove existing
              one</md-subheader
            >
          </md-card-header>

          <md-card-content>
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-field>
                  <label for="newCategory">Category name</label>
                  <md-input
                    v-model="form2.newCategory"
                    name="newCategory"
                  ></md-input>
                  <span class="md-helper-text">For example: Massage</span>
                </md-field>
              </div>
              <div class="md-layout-item">
                <md-field>
                  <label for="categoriesToRemove"
                    >Categories to be removed</label
                  >
                  <md-select
                    name="categoriesToRemove"
                    v-model="form2.selectedCategoryToRemove"
                    multiple
                    placeholder="Remove Category"
                  >
                    <md-option
                      v-for="item in categories"
                      :key="item"
                      :value="item"
                      >{{ item }}</md-option
                    >
                  </md-select>
                  <span class="md-helper-text">Select any to remove</span>
                </md-field>
              </div>
            </div>
          </md-card-content>

          <md-card-actions>
            <md-button @click="cancelCategoryEdit">Cancel</md-button>
            <md-button
              type="submit"
              class="md-raised"
              :disabled="!enableCategoryChanges"
              >{{ saveButtonText }}</md-button
            >
          </md-card-actions>
        </md-card>
      </form>
    </transition>
    <app-time-slot
      :from="0"
      :to="3"
      :cols="7"
      :interval="5"
      :skip="2"
      title="Pick a duration for this treatment"
      subtitle="from 10 min to 3 hours"
    ></app-time-slot>
    <md-tooltip md-direction="bottom" v-if="isValidTreatment"
      >Click "Add Treatment" button to submit your input.</md-tooltip
    >
  </div>
</template>

<script>
import { eventBus } from "../../eventbus";
import TimeSlot from "../../Shared/TimeSlot";

export default {
  name: "NewTreatment",
  data: function () {
    return {
      form1: {
        treatmentName: null,
        priceText: null,
        selectedCategory: null,
      },

      from: "0",
      to: "3",
      showCreateCategory: false,

      form2: {
        newCategory: null,
        selectedCategoryToRemove: [],
        defaultSaveBtnText: "Save",
      },
    };
  },
  components: {
    appTimeSlot: TimeSlot,
  },
  computed: {
    isValidTreatment() {
      var isValid = false;
      if (
        this.form1.selectedCategory != null &&
        this.form1.selectedCategory.length &&
        !this.isEmptyText(this.form1.treatmentName)
      ) {
        isValid = true;
      }

      eventBus.addTreatmentFormValidation(isValid);
      return isValid;
    },
    enableCategoryChanges() {
      return this.saveButtonText != this.form2.defaultSaveBtnText;
    },
    saveButtonText() {
      if (
        this.removeCategoryButtonText == "" &&
        this.addCategoryButtonText == ""
      )
        return this.form2.defaultSaveBtnText;
      else
        return this.addCategoryButtonText + " " + this.removeCategoryButtonText;
    },
    removeCategoryButtonText() {
      let text = "";
      let nrText = "one";
      let prefixText = "and remove ";
      let nrCats = this.form2.selectedCategoryToRemove.length;

      if (this.form2.selectedCategoryToRemove.length) {
        switch (nrCats) {
          case 1:
            nrText = "one";
            break;
          case 2:
            nrText = "two";
            break;
          case 3:
            nrText = "three";
            break;
          default:
            nrText = nrCats;
            break;
        }
        if (this.isEmptyText(this.form2.newCategory))
          text =
            "Remove " + nrText + (nrCats > 1 ? " categories" : " category");
        else text = prefixText + nrText;
      }
      return text;
    },
    addCategoryButtonText() {
      let text = "";
      if (!this.isEmptyText(this.form2.newCategory)) text = "Save Category";
      return text;
    },
    categories() {
      return (this.menuData || []).map((m) => m.cat);
    },
  },
  methods: {
    cancelCategoryEdit: function () {
      this.showCreateCategory = false;
      this.form2.selectedCategoryToRemove = [];
      this.form2.newCategory = null;
    },
    addRemoveCategory: function () {
      // TODO remove categories
      // selectedCategoryToRemove

      const newCategory = this.form2.newCategory;

      this.savingInProgress = true;
      if (this.isEmptyText(newCategory)) return;

      console.log("TODO add new cat");
      return;
      // return this.$store.sharedState
      //   .addNewCategory(newCategory)
      //   .then((data) => {
      //     console.log("Category successfully written!", data);
      //     self.savingInProgress = false;
      //   })
      //   .catch((error) => {
      //     self.savingInProgress = false;
      //     console.error("Error writing category: ", error);
      //   });
    },
    //todo move to shared
    isEmptyText: function (text) {
      return !text || text.trim().length == 0;
    },
    addTreatment: function () {
      var treatment = {
        name: this.form1.treatmentName,
        categories: this.form1.selectedCategory,
        price: this.form1.priceText,
      };

      console.log("TODO add new treatmetn", treatment);
      return;
      // return this.store.sharedState
      //   .addNewTreatment(treatment)
      //   .then((data) => {
      //     console.log("Treatment successfully written!", data);
      //     self.savingInProgress = false;
      //     eventBus.newTreatmentCreated(data?.id);
      //   })
      //   .catch((error) => {
      //     self.savingInProgress = false;
      //     console.error("Error writing treatment: ", error);
      //   });
    },
  },
  created: function () {
    var self = this;

    eventBus.$on("add-treatment-click", function () {
      self.addTreatment();
    });
  },
  beforeDestroy: function () {
    // disable all listeners for this event
    eventBus.$off("add-treatment-click");
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>